export default __webpack_public_path__ + "python.fcb2cb20.png";